// extracted by mini-css-extract-plugin
export default {"number":"W9dvy","button":"qCTIN","links":"VegrI"};